import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const EMarketingAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.eMarketingPage,
      component: React.lazy(() => import('./pages/EMarketingPage')),
    },
  ],
};

export default EMarketingAppConfig;
